<style scoped lang="less" rel="stylesheet/less">
.playgame {
  width: 100%;
  height: 100%;

  background: #000;
}
.header {
  position: absolute;
  z-index: 110;
  height: 70px;
  padding-top: 20px;
  span {
    position: absolute;
    width: 62px;
    height: 50px;
    background: rgba(0, 0, 0, 0.08)
      url("../../../assets/img/common/arrow_left.png") no-repeat center center;
    background-size: 100% 100%;
    border-radius: 25px 8px 8px 25px;
    left: 30px;
    top: 10px;
    &:hover {
      background: rgba(0, 0, 0, 0.16)
        url("../../../assets/img/common/arrow_left.png") no-repeat center center;
      background-size: 100% 100%;
    }
  }
}

.bg {
  width: 100%;
  height: 100%;
  background: url(/static/img/game/bg.png) no-repeat;
  z-index: 100;
  position: relative;
  overflow: hidden;
  background-size: 100% 100%;
  .left_bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 50%;
    height: 100%;
    background: url(/static/img/game/left_bg.png) no-repeat left;
    background-size: auto 100%;
  }
  .right_bg {
    position: absolute;
    top: 0;
    right: 0;
    width: 50%;
    height: 100%;
    background: url(/static/img/game/right_bg.png) no-repeat right;
    background-size: auto 100%;
  }
}
</style>
<template>
  <div class="playgame">
    <div class="header">
      <span @click="go_gameMenu" class="cursor"></span>
    </div>
    <!--课件-->
    <kejian :gameIndex="gameIndex" :topicType="6" />
    <div v-if="showbg" class="bg">
      <div class="left_bg"></div>
      <div class="right_bg"></div>
    </div>
    <Toast :showText="showText" v-if="showToast" @toastCallBack="toastCallBack" />
  </div>
</template>

<script>
import kejian from "../video/answer/kejian"; //课件题
import Toast from "../../../components/basic/toast";
export default {
  name: "palygame",
  data() {
    return {
      gameIndex: "",
      showbg: true,
      showText: "加载失败",
      showToast: false,
      backSoundName:''
    };
  },
  components: {
    kejian,
    Toast
  },
  created() {
    this.gameIndex = this.$route.query.index;
    this.eventHub();
  },
  mounted() {
    setTimeout(() => {
      this.$loading.showbg();
    }, 50);
  },
  methods: {

    go_gameMenu() {
   
      this.$router.push("/gameMenu");
    },
    toastCallBack() {
      this.showToast = false;
    },
    eventHub() {
      this.$root.eventHub.$off("loadGameSuccess");
      this.$root.eventHub.$off("loadGameFail");
      this.$root.eventHub.$on("loadGameSuccess", () => {
        this.showbg = false;
        this.$loading.close();
      });
      this.$root.eventHub.$on("loadGameFail", () => {
        this.showToast = true;
        this.$loading.close();
      });
    }
  },
  beforeDestroy() {
    this.$loading.close();
  }
};
</script>


// WEBPACK FOOTER //
// src/components/bussiness/game/playgame.vue